import { useState } from "react";

const useGridContextManager = () => {
  const [grid, setGrid] = useState({});
  return [grid, setGrid];
};

export default useGridContextManager;
